import React from 'react';
import classNames from 'classnames';
import { Button } from '@eventbrite/eds-button';
import {
    CollapsiblePaneLayout,
    ModalContent,
    ModalContentChildren,
    ModalFooter,
} from '@eventbrite/eds-modal';
import ConnectedCartSummary from '../../components/CartSummary';
import ReservedPane from '../pane/ReservedPane';
import Pane from '../pane/Pane';
import { connectPane } from '../pane/connectPane';
import { getDisplayClasses } from '../../utils/displayClasses';
import './pageTemplate.scss';

const ConnectedPaneComponent = connectPane(Pane);
const ConnectedReservedPaneComponent = connectPane(ReservedPane);

const PageTemplate = ({
    children,
    containerClassName,
    ctaNode,
    ctaText,
    ctaType,
    extraModalBodyProps,
    extraPaneProps,
    headerActionIconType,
    isPaneOpen,
    isSubmitDisabled,
    keepDisabledStyleWhileLoading,
    handleSubmit,
    hasTopMargin = true,
    hasHorizontalGutters = true,
    headerActionTitle,
    notificationOptions,
    onPaneToggle,
    onHeaderAction,
    secondaryTitle,
    templateProps,
    fullWidthTopContent,
    fullWidthBottomContent,
    title,
    dataSpec,
    tertiaryNode,
    footerMessageNode,
    modalFooterNode,
    loadingLayerNode,
    showCartSummaryButton = true,
}) => {
    const { isReservedSeating, totalTicketQuantity, isSubmitting } =
        templateProps;
    const PaneComponent = isReservedSeating
        ? ConnectedReservedPaneComponent
        : ConnectedPaneComponent;
    const containerClasses = hasHorizontalGutters
        ? classNames(getDisplayClasses({ hasTopMargin }), containerClassName)
        : containerClassName;
    const __footerContainerClassName = classNames(
        getDisplayClasses(),
        'modal-footer',
        ctaNode ? 'modal-footer-cta-node' : '',
    );
    const shouldShowModalFooter = !!(modalFooterNode || ctaText || ctaNode);

    const defaultCtaButton = ctaText ? (
        <div className="eds-align--right">
            <Button
                onClick={handleSubmit}
                style={ctaType || 'fill'}
                disabled={isSubmitDisabled}
                keepDisabledStyleWhileLoading={keepDisabledStyleWhileLoading}
                data-spec={'eds-modal__primary-button'}
                data-automation={'eds-modal__primary-button'}
                isLoading={isSubmitting}
            >
                {ctaText}
            </Button>
        </div>
    ) : null;

    const content = (
        <ModalContent
            title={title}
            secondaryTitle={secondaryTitle}
            notificationOptions={notificationOptions}
            headerActionIconType={headerActionIconType}
            headerActionTitle={headerActionTitle}
            onHeaderAction={onHeaderAction}
            {...extraModalBodyProps}
        >
            <ModalContentChildren>
                {fullWidthTopContent}
                <div className={containerClasses} data-spec={dataSpec}>
                    {children}
                </div>
                {fullWidthBottomContent}
            </ModalContentChildren>

            {shouldShowModalFooter && (
                <ModalFooter
                    __footerContainerClassName={__footerContainerClassName}
                >
                    <div className="modal-footer__wrapper">
                        {tertiaryNode || (
                            <>
                                {footerMessageNode}
                                {showCartSummaryButton && (
                                    <ConnectedCartSummary
                                        isPaneOpen={isPaneOpen}
                                        onClick={onPaneToggle}
                                    />
                                )}
                                {ctaNode}
                            </>
                        )}
                        {modalFooterNode || defaultCtaButton}
                    </div>
                </ModalFooter>
            )}
        </ModalContent>
    );
    return showCartSummaryButton ? (
        <>
            <CollapsiblePaneLayout
                pane={
                    <PaneComponent
                        {...extraPaneProps}
                        ticketQuantity={totalTicketQuantity}
                    />
                }
                content={content}
                isPaneOpen={isPaneOpen}
            />
            {loadingLayerNode}
        </>
    ) : (
        content
    );
};

export default PageTemplate;
